import { createTheme, alpha } from "@mui/material/styles";

export const colors = {
    primary: "#1976d2",
    primaryLight: "#42a5f5",
    primaryDark: "#1565c0",
    background: "#f5f7fa",
    paper: "#ffffff",
    error: "#d32f2f",
    success: "#2e7d32",
};

export const appTheme = createTheme({
    palette: {
        primary: {
            main: colors.primary,
            light: colors.primaryLight,
            dark: colors.primaryDark,
        },
        secondary: {
            main: colors.primaryDark,
        },
        background: {
            default: colors.background,
            paper: colors.paper,
        },
        success: {
            main: colors.success,
        },
        error: {
            main: colors.error,
        },
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        h4: {
            fontWeight: 600,
        },
        h6: {
            fontWeight: 500,
        },
    },
    components: {
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                    border: "1px solid rgba(0, 0, 0, 0.05)",
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    fontWeight: 600,
                },
            },
        },
    },
});

export const navLinkStyles = {
    default: {
        background: "rgba(255, 255, 255, 0.2)",
        hoverBackground: "rgba(255, 255, 255, 0.35)",
    },
    danger: {
        background: "rgba(220, 53, 69, 0.85)",
        hoverBackground: "rgba(220, 53, 69, 1)",
    },
};

export const pageBackgroundSx = {
    minHeight: "100vh",
    bgcolor: "background.default",
    p: { xs: 0.5, sm: 1 },
};

export const loginBackgroundSx = (theme) => ({
    minHeight: "100vh",
    bgcolor: "primary.main",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
});

export const primaryTint = (opacity = 0.05) => alpha(colors.primary, opacity);
